import React from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Switch, Route, NavLink } from 'react-router-dom'
import { Icon, Label, Loader, Button, Header } from 'semantic-ui-react'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'

import {
  logoutDashboard, initializeDashboard,
  loginDashboard, resetDashboard, checkAuth,
} from '../actions/pages'
import { openModal } from '../actions/geoSections'
import { DEFAULT_LOCALE } from '../constants'
import GeoCategory from './GeoCategory'
import NewCategory from './NewCategory'
import EmptyCategory from './EmptyCategory'
import SettingsHomeLayout from './SettingsHomeLayout'
import LoginPageLayout from './LoginPageLayout'
import ErrorWrapper from './ErrorWrapper'
import SectionDropdown from './fields/SectionDropdown'
import SectionModal from './SectionModal'
import CategoryListIcon from './CategoryListIcon'
import Webcams from './Webcams'

import styles from './styles.css'


const categoryListItemStyle = (selectedCategoryId, category) => ({
  display: 'flex', alignItems: 'center', borderRadius: '3px', cursor: 'pointer', height: '50px',
  padding: '5px', backgroundColor: selectedCategoryId === category.id ? '#F0F0FF' : null,
})

const categoryListTextStyle = {
  fontWeight: 'bold', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
}

const leftPanelStyle = {
  padding: '0 15px 0 0',
  boxShadow: '1px 0 rgba(0,0,0,.1)',
  overflowY: 'auto',
}

export class DashboardLayout extends React.Component {

  componentDidMount() {
    this.props.checkAuth()
  }

  componentDidUpdate() {
    const { isInitialized, isInitializing, isLoggedIn, initializeDashboard } = this.props
    if (!isInitialized && !isInitializing && isLoggedIn) initializeDashboard()
  }

  redirectTo = path => () => this.props.history.push(path)

  getCategoriesList = () => {
    const selectedCategoryId = this.props.match.params.categoryId
    const { categoryIds, geoCategories, geoSections, selectedSectionId } = this.props
    const selectedSection = selectedSectionId && geoSections[selectedSectionId]

    const filteredCategoryIds = selectedSection ?
      categoryIds.filter(
        categoryId =>
          Array.isArray(selectedSection.categories) &&
          selectedSection.categories.includes(categoryId)
      ) :
      categoryIds

    return filteredCategoryIds.length ? filteredCategoryIds.map(cid => {
      const category = geoCategories[cid]
      return <div
        key={category.id} onClick={this.redirectTo(`/${category.id}`)}
        style={categoryListItemStyle(selectedCategoryId, category)}
      >
        <CategoryListIcon category={category}/>
        <div style={categoryListTextStyle}>{category.locales[DEFAULT_LOCALE].name}</div>
      </div>
    }) : <div>Нет категорий{selectedSectionId ? ' в этом разделе' : ''}</div>
  }

  render() {
    const {
      isInitialized, isInitializing, error, isLoggedIn, isCheckingLogin, isLoggingIn,
      loginDashboard, resetDashboard, openModal, selectedSectionId,
    } = this.props

    if (!isCheckingLogin && !isLoggedIn) {
      return <LoginPageLayout onLogin={loginDashboard} isLoggingIn={isLoggingIn}/>
    } else if (isInitializing) {
      return <Loader active/>
    } else if (error) {
      return <div style={{ color: 'red' }}>{error.toString()}</div>
    } else if (!isInitialized) {
      return <span/>
    }

    return (
      <AbsoluteDiv style={{ minWidth: '1200px', margin: '15px' }}>
        <AbsoluteDiv attached='left' width='250px'
          style={{ ...leftPanelStyle, maxHeight: '315px' }}
        >
          <Header as='h3'>
            <NavLink to='/' className={styles.inactiveLink} activeClassName={styles.activeLink}
              isActive={(match, location) => location.pathname === '/'}>
              <Icon name='globe'/>
              <Header.Content>Globe3D Dashboard</Header.Content>
            </NavLink>
            {/* <Icon
              style={{ float: 'right', cursor: 'pointer' }}
              name='cogs' onClick={this.redirectTo('/settings')}
            /> */}
          </Header>
          <Header as='h4'>
            <NavLink to='/webcams' className={styles.inactiveLink} activeClassName={styles.activeLink}
              isActive={(match, location) => /^\/webcams/.test(location.pathname)}>
              <Icon name='video'/>
              <Header.Content>Камеры</Header.Content>
            </NavLink>
          </Header>
          <Header as='h4'>Разделы</Header>
          <SectionDropdown/>
          <Button
            basic fluid style={{ margin: '15 0 0' }}
            color={selectedSectionId ? 'green' : 'blue'}
            icon={selectedSectionId ? 'pencil' : 'plus'}
            content={selectedSectionId ? 'Редактировать текущий' : 'Добавить раздел'}
            onClick={openModal}
          />
          <Header as='h4'>Категории</Header>
          <Label
            basic={window.location.pathname !== '/new-category'}
            color='blue' as={NavLink}
            to='/new-category'
          >
            <Icon name='plus'/> Добавить категорию
          </Label>
        </AbsoluteDiv>
        <AbsoluteDiv attached='left' width='250px'
          style={{ ...leftPanelStyle, marginTop: '315px' }}
        >
          <div style={{ padding: '15 0 0', overflowY: 'auto', overflowX: 'hidden' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>{this.getCategoriesList()}</div>
          </div>
        </AbsoluteDiv>
        <AbsoluteDiv left='250px' style={{ marginLeft: '15px' }}>
          <ErrorWrapper onReset={resetDashboard}>
            <Switch>
              <Route exact path='/' component={EmptyCategory}/>
              <Route path='/settings' component={SettingsHomeLayout}/>
              <Route path='/new-category' component={NewCategory}/>
              <Route path='/webcams'>
                <Webcams/>
              </Route>
              <Route path='/:categoryId?' component={GeoCategory}/>
            </Switch>
          </ErrorWrapper>
        </AbsoluteDiv>
        <SectionModal/>
      </AbsoluteDiv>
    )
  }

}

DashboardLayout.propTypes = {
  isInitialized: PropTypes.bool,
  isInitializing: PropTypes.bool,
  error: PropTypes.object,
  isLogged: PropTypes.bool,
  isLoggingIn: PropTypes.bool,
  isCheckingLogin: PropTypes.bool,
  initializeDashboard: PropTypes.func.isRequired,
  loginDashboard: PropTypes.func.isRequired,
  resetDashboard: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    ...state.dashboard,
    geoCategories: state.geoCategories,
    geoSections: state.geoSections,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    checkAuth,
    initializeDashboard,
    loginDashboard,
    logoutDashboard,
    resetDashboard,
    openModal,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardLayout))
